import React from 'react';
import { Ear, Zap, Shield, Cpu } from 'lucide-react';
import './Features.css';

const features = [
  {
    icon: <Ear />,
    title: 'Intelligent Audio Detection',
    description: 'StopSpoti monitors system audio APIs directly, accurately detecting when any browser or game starts playing sound without needing complex setups.',
    className: 'card-wide'
  },
  {
    icon: <Zap />,
    title: 'Zero Configuration',
    description: 'Launch the script, click Start Monitoring, and forget it. No tricky audio cables or routing required.',
    className: 'card-square'
  },
  {
    icon: <Cpu />,
    title: 'Resource Efficient',
    description: 'Built to run forever. Advanced garbage collection techniques ensure absolute minimal CPU and RAM usage over months of uptime.',
    className: 'card-square'
  },
  {
    icon: <Shield />,
    title: 'Seamless Resumption',
    description: 'Waits a polite 1.5 seconds after the other application goes quiet to prevent stuttering during dialogue pauses, then seamlessly resumes your Spotify.',
    className: 'card-wide'
  }
];

const Features = () => {
  return (
    <section id="features" className="features container">
      <div className="features-header">
        <h2>Why StopSpoti?</h2>
        <p>Built completely independently from the Spotify API for zero-latency control.</p>
      </div>
      
      <div className="bento-grid">
        {features.map((feature, index) => (
          <div key={index} className={`bento-card ${feature.className}`}>
            <div className="card-glow"></div>
            <div className="card-content">
              <div className="icon-wrapper">
                {feature.icon}
              </div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
